#import "./imageRevertPayload.gql"

mutation RevertStockImage($input: RevertStockImageInput!) {
  revertStockImage(input: $input) {
    ... on StockImage {
      ...ImageRevertPayload
      externalId
      provider
      license
    }
    __typename
  }
}
